export function secondsBetween(dateAInput, dateBInput) {
    const dateA = dateAInput instanceof Date ? dateAInput : new Date(dateAInput);
    const dateB = dateBInput instanceof Date ? dateBInput : new Date(dateBInput);

    const diffMillis = dateA.getTime() - dateB.getTime();

    return diffMillis / 1000;
}

export function secondsSince(date) {
    return secondsBetween(new Date(), date);
}

export function secondsUntil(date) {
    return secondsBetween(date, new Date());
}